import { BonusType } from '@/enums'
import { FieldState, StateSchema } from '@/hooks/form/models'
import i18n from 'i18n'

import { Restriction } from '@/state/bonus-engine/models'
import { GamesList } from '@/state/wagering-contribution/models'

export const getBonusType = (type: string) => {
  switch (type) {
    case BonusType.CASINO_STANDARD:
      return i18n.t(`bonusTypes.CASINO_STANDARD`)

    case BonusType.SPORTS_STANDARD:
      return i18n.t(`bonusTypes.SPORT_STANDARD`)

    // case BonusType.FREE_PLAY:
    //   return i18n.t(`bonusTypes.FREE_PLAY`)

    case BonusType.FREE_SPINS:
      return i18n.t(`bonusTypes.FREE_SPINS`)

    case BonusType.BETSOFT_CASINO:
      return i18n.t(`bonusTypes.BETSOFT_CASINO`)

    default:
      return i18n.t(`bonusTypes.CASINO_STANDARD`)
  }
}

export const getListOfGames = (games: FieldState) => {
  return games.value.length > 0
    ? games.value.map((game: Restriction) => {
        return {
          type: game.type,
          validationId: game.validationId,
          gameProviderId: game.gameProviderId,
          action: game.action,
        }
      })
    : []
}

/**
 * Free spins bonuses store plain BGaming game codes, so the saved codes have to
 * be matched back against the games list to be shown as options in the form
 */
export const getFreeSpinGamesOptions = (
  gameCodes: string[],
  gamesList: GamesList[],
) =>
  gameCodes.map((gameCode: string) => {
    const game = gamesList.find((item) => item.gameCode === gameCode)
    return {
      label: game?.name || gameCode,
      gameCode,
      validationId: game?.id.toString() || '',
      vendorExternalID: game?.vendorExternalID,
      type: BonusType.FREE_SPINS,
      action: 1,
    }
  })

/** The bonus engine expects freeSpinGames as a flat list of BGaming game codes */
export const getListOfFreeSpinGames = (games: FieldState): string[] =>
  games.value.length > 0
    ? games.value.map((game: { gameCode: string }) => game.gameCode)
    : []

export const setListGames = (
  setFormValues: (newState: StateSchema) => void,
  gamesState: Restriction[],
  gamesList: GamesList[],
  state: StateSchema,
) => {
  setFormValues({
    ...state,
    games: {
      value: gamesState
        ? gamesState.map((game: Restriction) => {
            const newGame = gamesList.find(
              (item) => item.id === Number(game.validationId),
            )
            return {
              ...game,
              label: newGame?.name,
            }
          })
        : [],
      error: '',
    },
  })
}
